import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import { getSrc } from './UserPhoto/UserPhoto';

const styled = withStyles(theme => {
  return {
    avatar: {
      borderRadius: '50%',
      backgroundSize: 'contain'
    }
  };
});

// const getSrc = user => {
//   if (user.photos.length > 0) {
//     let filename = user.photos[0].images[0].filename;
//     if (user.photos[0].images.length > 1) {
//       filename = user.photos[0].images[1].filename;
//     } else {
//       filename = user.photos[0].images[0].filename;
//     }
//     if (filename.indexOf('http') === -1) {
//       return `${process.env.REACT_APP_CDN_BASE}/${user._id}/${
//         user.photos[0]._id
//       }/${filename}`;
//     } else {
//       return filename;
//     }
//   } else {
//     if (user.gender === 'male') {
//       return maleSrc;
//     } else {
//       return femaleSrc;
//     }
//   }
// };

const Avatar = ({ classes, user, size }) => (
  <div
    className={classes.avatar}
    style={{
      width: size,
      height: size,
      backgroundImage: `url("${getSrc(user, 0)}")`,
      backgroundSize: 'cover'
    }}
  />
);

export default styled(Avatar);
